import dovydas from "@/assets/images/team/dovydas.jpg";
import aureja from "@/assets/images/team/aureja.jpg";
import vaidas from "@/assets/images/team/vaidas.jpg";
import jokubas from "@/assets/images/team/jokubas.jpg";
import tomas from "@/assets/images/team/tomas.jpg";
import rimvydas from "@/assets/images/team/rimvydas.jpg";
import sandra from "@/assets/images/team/sandra.jpg";
import liepaite from "@/assets/images/team/aleksandra.jpg";
import vestina from "@/assets/images/team/vestina.jpg";
import erika from "@/assets/images/team/erika.png";
import asta from "@/assets/images/team/asta.png";
import ruta from "@/assets/images/team/ruta.png";
import luka from "@/assets/images/team/luka.jpg";
import jolita from "@/assets/images/team/jolita.png";

export interface TeamMember {
  id: number;
  name: string;
  position: string;
  img_src: string;
  alt: string;
  content?: TeamContent;
}

interface TeamContent {
  label: string;
  description: string[];
  achievements?: Achievements[];
  img_large_src: string;
  recommended_blogs_label?: string;
  recommended_blogs_ids?: number[];
  quote?: string | string[];
}

interface Achievements {
  id: number;
  label: string;
  item: AchievementsItem[];
}

interface AchievementsItem {
  id: number;
  rows: AchievementsItemRow[];
}

interface AchievementsItemRow {
  id: number;
  text: string;
}

export const TEAM_CONTENT_VALUES: TeamMember[] = [
  {
    id: 1,
    name: "Dovydas Čalnaris, M.Pharm",
    position: "CEO & Co-founder",
    img_src: dovydas,
    alt: "Dovydas Čalnaris",
    content: {
      img_large_src: dovydas,
      label:
        "Kuriame sveikatos priežiūrą, kuri veikia dar iki atsirandant ligai.",
      description: [
        "Dovydas yra „Telomera“ vizijos architektas – farmacijos magistras, verslininkas ir inovacijų šalininkas. Jis įkūrė įmonę siekdamas pakeisti nusistovėjusį požiūrį į sveikatos priežiūrą – nuo vėlyvos ligų diagnostikos prie prevencijos, paremtos genetiniais, epigenetiniais ir biocheminiais duomenimis. ",
        "Dovydo tikėjimas, kad kiekvienas žmogus nusipelno aiškumo ir kontrolės savo sveikatos kelyje, atsispindi kiekviename Telomeros sprendime.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2020</b> - Baigtas Lietuvos sveikatos mokslų universitetas",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Dovydo rekomenduojami straipsniai",
      recommended_blogs_ids: [1, 2, 3],
    },
  },
  {
    id: 2,
    name: "Aurėja Čalnarė",
    position: "COO & Co-founder",
    img_src: aureja,
    alt: "Aurėja Čalnarė",
    content: {
      img_large_src: aureja,
      label:
        "Vizija be struktūros – tik graži idėja. Mano darbas – paversti ją realybe.",
      description: [
        "Aurėja yra strateginis Telomeros variklis – nuo idėjos iki įgyvendinimo. Tarptautinio verslo žinias, įgytas ISM universitete, ji papildo teisės išmanymu studijuodama sveikatos teisę MRU. Ši unikali kompetencijų dermė leidžia Aurėjai koordinuoti sudėtingus projektus, kurti tvarius partnerystės modelius ir užtikrinti, kad kiekvienas Telomeros sprendimas atitiktų tiek rinkos, tiek žmogaus lūkesčius. Ji rūpinasi, kad mūsų vizija veiktų praktiškai – diena iš dienos.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2018</b> - Baigtas ISM ekonomikos ir vadybos universitetas",
                },
                {
                  id: 2,
                  text: "<b>2025</b> - Baigtas Mykolo Romerio universitetas",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Aurėjos rekomenduojami straipsniai",
      recommended_blogs_ids: [2, 3, 4],
    },
  },
  {
    id: 3,
    name: "Vaidas Dirsė, Ph.D",
    position: "Medicinos biologas, mokslų daktaras",
    img_src: vaidas,
    alt: "Vaidas Dirsė",
    content: {
      img_large_src: vaidas,
      label:
        "Ilgaamžiškumas – ne ateities svajonė, o šiandienos sprendimų rezultatas.",
      description: [
        "Vaidas Dirsė – medicinos mokslų daktaras, genetikas ir vienas iš ilgaamžiškumo (longevity) tyrimų pradininkų Lietuvoje. Jau beveik 17 metų jis gilinasi į tai, kaip miego, streso, gliukozės bei fizinio aktyvumo rodikliai veikia epigenetinį laikrodį ir biologinį amžių.",
        "Dirbdamas su Telomera, Vaidas taiko moksliškai pagrįstus genetinius ir epigenetinius tyrimus, siekdamas padėti žmonėms suprasti savo organizmo senėjimo procesus ir pritaikyti individualizuotas prevencines strategijas. Jo tikslas – ne tik ilgesnis, bet ir kokybiškesnis gyvenimas kiekvienam.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2004–2008</b> Vilniaus universitetas, Gamtos mokslų fakultetas – Biologijos bakalauras",
                },
                {
                  id: 2,
                  text: "<b>2008–2010</b> Vilniaus universitetas, Gamtos mokslų fakultetas – Biologijos magistras",
                },
                {
                  id: 3,
                  text: "<b>2015–2019</b> Vilniaus universitetas, Medicinos fakultetas – Medicinos mokslų daktaras",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "Darbo patirtis",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2008–2011</b> Vilniaus Universitetas, Medicinos fakultetas – Jaunesnysis mokslo darbuotojas",
                },
                {
                  id: 2,
                  text: "<b>2010–2011</b> VUL Santaros klinikos, Medicininės genetikos centras – Medicinos genetikas",
                },
                {
                  id: 3,
                  text: "<b>nuo 2011</b> VUL Santaros klinikos, Hematologijos, onkologijos ir transfuziologijos centras – Medicinos biologas",
                },
                {
                  id: 4,
                  text: "<b>nuo 2012</b> NOPHO (Nordic Society of Pediatric Hematology and Oncology) – Leukemijos biologijos grupės ekspertas",
                },
                {
                  id: 5,
                  text: "<b>nuo 2019</b> Santaros klinikų medicinos darbuotojų profesinė sąjunga – Pirmininkas",
                },
                {
                  id: 6,
                  text: "<b>nuo 2020</b> MB Ilgo gyvenimo genetika – Direktorius / Mokslinės konsultacijos",
                },
                {
                  id: 7,
                  text: "<b>nuo 2020</b> Jungtinė Santaros klinikų profesinių sąjungų atstovybė – Pirmininkas",
                },
                {
                  id: 8,
                  text: "<b>2021–2023</b> Projektas vaikų onkologijos išgyvenamumui gerinti – Projekto specialistas",
                },
                {
                  id: 9,
                  text: "<b>nuo 2022</b> Healthnews.com – Mokslinių tekstų autorius (medicinos skiltis)",
                },
                {
                  id: 10,
                  text: "<b>nuo 2022</b> UAB Genotipas – Medicinos biologas",
                },
                {
                  id: 11,
                  text: "<b>2024–2025</b> Biomedicininis tyrimas „daugiacentris, atviras, palyginamųjų grupių tyrimas, skirtas įvertinti TLM01 maisto papildų komponento derinio vartojimo poveikį sveikiems asmenims – Pagrindinis tyrėjas",
                },
              ],
            },
          ],
        },
      ],
      quote:
        "Telomera - tai pirmas atvejis Lietuvoje, kai rimtai žiūrima į prevencinę - personalizuotą mediciną, pasitelkiant ne tik genetiką, bet ir visą profesionalų komandą.",
      recommended_blogs_label: "Vaido rekomenduojami straipsniai",
      recommended_blogs_ids: [3, 4, 5],
    },
  },
  {
    id: 4,
    name: "Rimvydas Norvilas, Ph.D",
    position: "Genetikas",
    img_src: rimvydas,
    alt: "Rimvydas Norvilas",
    content: {
      img_large_src: rimvydas,
      label:
        "Genomas – tai ne paslaptis, o instrukcija tiems, kurie moka ją skaityti.",
      description: [
        "Rimvydas Norvilas yra medicinos biologas, turintis ilgametę patirtį genetikos ir hematologijos srityse. Jis glaudžiai bendradarbiauja su Telomera, padėdamas įdiegti viso genomo sekoskaitos tyrimus į klinikinę praktiką. Jo kompetencija apima molekulinės genetikos metodus, tokius kaip PCR, DNA sekoskaita ir RNA analizė, kurie yra esminiai šiuolaikinėje diagnostikoje. Rimvydas taip pat aktyviai dalyvauja moksliniuose tyrimuose, siekdamas pritaikyti naujausius mokslo pasiekimus pacientų naudai.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2015</b> - Baigtas Vilniaus universitetas",
                },
                {
                  id: 2,
                  text: "<b>2021</b> - Įgytas daktaro laipsnis Vilniaus universitete",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Rimvydo rekomenduojami straipsniai",
      recommended_blogs_ids: [4, 5, 6],
    },
  },
  {
    id: 5,
    name: "Sandra Tumėnė, MD",
    position: "Gydytoja genetikė, akušerė ginekologė",
    img_src: sandra,
    alt: "Sandra Tumėnė",
    content: {
      img_large_src: sandra,
      label:
        "Gerai suprastas genomas – kelias į aiškius sprendimus kiekvienam pacientui.",
      description: [
        "Sandra Tumėnė – gydytoja genetikė ir akušerėginekologė, turinti daugiau nei 10 metų klinikinės patirties. Jos darbas apima platų spektrą – nuo prenatalinės diagnostikos iki paveldimų ligų vertinimo, o didžiausias dėmesys skiriamas moters sveikatai įvairiais gyvenimo etapais.",
        "Telomeroje dr. Tumėnė prisideda prie viso genomo sekoskaitos tyrimų diegimo, padėdama pritaikyti genetinius duomenis individualizuotai moterų sveikatos priežiūrai. Jos kompetencijos apima neinvazinius prenatalinius tyrimus (NIPT, PRISCA), vaisiaus echoskopijas ir išsamias genetines konsultacijas, padedančias anksti atpažinti rizikas ir imtis prevencinių sprendimų.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2003–2009</b> Kauno medicinos universitetas – Medicinos magistrė",
                },
                {
                  id: 2,
                  text: "<b>2006–2008</b> Krašto apsaugos ministerija – Karo medicinos gydytojo kvalifikacija, atsargos leitenantė",
                },
                {
                  id: 3,
                  text: "<b>2009–2010</b> Kauno medicinos universitetas – Internatūra – medicinos gydytojos kvalifikacija",
                },
                {
                  id: 4,
                  text: "<b>2010–2014</b> Vilniaus universitetas – Genetikos rezidentūra – gydytojos genetikės kvalifikacija",
                },
                {
                  id: 5,
                  text: "<b>2014–2018</b> Vilniaus universitetas – Akušerijos ir ginekologijos rezidentūra – gydytojos akušerės ginekologės kvalifikacija",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "Darbo patirtis",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2011–2021</b> VUL Santaros klinikos – Gydytoja genetikė",
                },
                {
                  id: 2,
                  text: "<b>nuo 2016</b> Hila – Gydytoja akušerė ginekologė ir genetikė",
                },
                {
                  id: 3,
                  text: "<b>nuo 2018</b> Centro poliklinika – Gydytoja akušerė ginekologė ir genetikė",
                },
                {
                  id: 4,
                  text: "<b>nuo 2021</b> V. Jonaitienės privati klinika – Gydytoja akušerė ginekologė ir genetikė",
                },
                {
                  id: 5,
                  text: "<b>nuo 2025</b> Medicija – vaisingumo klinika – Gydytoja akušerė ginekologė ir genetikė",
                },
                {
                  id: 6,
                  text: "<b>nuo 2025</b> Telomera – Gydytoja genetikė",
                },
              ],
            },
          ],
        },
      ],
      quote: [
        "Kiekviena konsultacija ir gydymo sprendimas Telomeroje - man yra galimybė parodyti rūpestę, profesionalumą ir duoti žmonėms saugumo jausmą",
        "Telomera mane įkvepia kelti sau aukštus standartus, gilinti žinias ir su dar didesne meile rūpintis žmonėmis",
      ],
      recommended_blogs_label: "Sandra rekomenduojami straipsniai",
      recommended_blogs_ids: [6, 7, 8],
    },
  },
  {
    id: 6,
    name: "Asta Križanauskienė, Ph.D",
    position: "Vadovaujanti mokslininkė",
    img_src: asta,
    alt: "Asta Križanauskienė",
    content: {
      img_large_src: asta,
      label:
        "Mokslas tampa prasmingas tada, kai padeda žmonėms realiame gyvenime.",
      description: [
        "Asta Križanauskienė – biomedicinos mokslų daktarė, turinti daugiau nei 28 metų patirtį biomedicinos ir onkologinės diagnostikos srityje. Jos profesinis kelias glaudžiai susijęs su molekuline diagnostika ir klinikinių tyrimų įgyvendinimu, ypač onkologijoje, kur ji dirbo su ankstyvos diagnostikos bei inovatyvių gydymo metodų kūrimu. ",
        "Asta yra viena iš vadovaujančių mokslininkių Telomeros klinikiniame tyrime, kuriame tiriamas David Sinclair knygoje aprašytų papildų poveikis senėjimo greičiui. Šis tyrimas yra vienas pirmųjų tokio pobūdžio projektų Europoje, vertinantis mokslo pagrindu sukurtų veikliųjų medžiagų įtaką epigenetiniam senėjimui.",
        "Jos tikslas – sujungti pažangiausius mokslo pasiekimus su praktiniais sprendimais, kurie padeda žmonėms gyventi ilgiau ir sveikiau.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2000</b> - Baigtas Vilniaus universitetas",
                },
                {
                  id: 2,
                  text: "<b>2007</b> - Įgytas daktaro laipsnis Lund universitete",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Astos rekomenduojami straipsniai",
      recommended_blogs_ids: [5, 6, 7],
    },
  },
  {
    id: 7,
    name: "Jokūbas Malikėnas, M.Pharm",
    position: "Farmacininkas",
    img_src: jokubas,
    alt: "Jokūbas Malikėnas",
    content: {
      img_large_src: jokubas,
      label:
        "Tinkamai parinkti junginiai – tai tarsi tiksli formulė tavo sveikatos potencialui atskleisti.",
      description: [
        "Jokūbas Malikėnas – farmacininkas, turintis daugiau nei 5 metų patirtį vaistų ir maisto papildų srityje. Telomeroje jis atsakingas už individualizuotų papildų ir medikamentų parinkimą, remiantis genetiniais, epigenetiniais ir kraujo tyrimų duomenimis. Jo tikslas – užtikrinti, kad kiekvienas pacientas gautų tik tai, kas iš tiesų reikalinga, tinkamomis dozėmis ir laiku. ",
        "Jokūbo kompetencija apima ne tik tradicinę farmaciją, bet ir gilų supratimą apie papildų poveikį organizmui.",
        "Jo darbas Telomeroje yra esminė ilgaamžiškumo programos dalis, kurioje farmacininkas surenka medicinos specialistų išvadas, visų tyrimų rezultatus ir parenka papildų ar medikamentų dozę bei vartojimo planą pagal paciento poreikius.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2014–2019</b> Lietuvos sveikatos mokslų universitetas – Farmacijos magistras, vaistininko praktikos licencija",
                },
                {
                  id: 2,
                  text: "<b>2021</b> LSMU – Išplėstinės praktikos vaistininko licencija",
                },
              ],
            },
          ],
        },
      ],
      quote: [
        "Man, kaip farmacininkui, Telomera yra naujos kartos, naujo požiūrio į sveikatą sistemos dalis, kurioje sveikata pacientui tampa asmenišku ir sąmoningu pasirinkimu.",
        "Telomeroje į žmogaus sveikatą žvelgiama visapusiškai, apjungiant skirtingas kryptis, tikslus ir ryšį su pacientu.",
        "Telomera man taip pat yra bendruomenė, kurioje susitinka žmonės, norintys geriau pažinti savo organizmą, rūpintis savimi ir priimti sprendimus, pagrįstus aiškia, patikrinta informacija bei mokslu, o ne spėjimais.",
      ],
      recommended_blogs_label: "Jokūbo rekomenduojami straipsniai",
      recommended_blogs_ids: [8, 9, 1],
    },
  },
  {
    id: 8,
    name: "Tomas Mikulis",
    position: "IT vadovas",
    img_src: tomas,
    alt: "Tomas Mikulis",
    content: {
      img_large_src: tomas,
      label:
        "Saugumas, greitis, patikimumas – trys dalykai, kuriais vadovaujuosi kiekviename sprendime.",
      description: [
        "Tomas Mikulis – informacinių technologijų specialistas, užtikrinantis, kad Telomeros technologinė infrastruktūra veiktų patikimai, greitai ir saugiai. Jo patirtis apima sistemų architektūrą, duomenų saugumą, IT sprendimų integraciją ir automatizaciją.",
        "Telomeroje Tomas atsakingas už visų IT procesų vystymą: nuo pacientų duomenų valdymo sistemų iki vidinių įrankių, kurie leidžia komandai dirbti efektyviai. Jis taip pat padeda diegti inovatyvius sprendimus, kurie palengvina specialistų darbą ir gerina pacientų patirtį.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2021</b> - Baigtas Vilniaus Gedimino technologijų universitetas",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Tomo rekomenduojami straipsniai",
      recommended_blogs_ids: [2, 3, 4],
    },
  },
  {
    id: 9,
    name: "Aleksandra Liepaitė, MD",
    position: "Šeimos gydytoja",
    img_src: liepaite,
    alt: "Aleksandra Liepaitė",
    content: {
      img_large_src: liepaite,
      label: "",
      description: [],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2012</b> Vilniaus universitetas – Medicinos magistrė ir gydytojo kvalifikacija; Medicinos internatūra",
                },
                {
                  id: 2,
                  text: "<b>2016</b> Vilniaus universitetas – Šeimos medicinos rezidentūra – šeimos gydytojo kvalifikacija",
                },
                {
                  id: 3,
                  text: "<b>nuo 2024</b> LSMU – Įvadinis psichoterapijos kursas (kognityvinė ir elgesio terapija), podiplominės studijos",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "Darbo patirtis",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2009–2012</b> Baltijos Amerikos klinika – Administracinis darbas",
                },
                {
                  id: 2,
                  text: "<b>2012–2016</b> Antakalnio poliklinika – Medicinos gydytoja",
                },
                {
                  id: 3,
                  text: "<b>2012–2016</b> Baltijos Amerikos klinika – Medicinos gydytoja",
                },
                {
                  id: 4,
                  text: "<b>nuo 2016</b> Antakalnio poliklinika – Šeimos gydytoja",
                },
                {
                  id: 5,
                  text: "<b>2016 - 2025</b> Baltijos Amerikos klinika – Šeimos gydytoja",
                },
                {
                  id: 6,
                  text: "<b>nuo 2025-10</b> Telomera – Šeimos gydytoja",
                },
              ],
            },
          ],
        },
      ],
      quote: [
        "Telomera man - tai galimybė matyti žmogų giliau.",
        "Čia svarbios ir detalės, ir visas sveikatos paveikslas - padedantis užbėgti problemoms už akių ir kryptingai spręsti esamas.",
        "Didžiausia Telomeros vertė - partnerystė su pacientu ir mokslu grįsti sprendimai, kurie įgalina žmogų aktyviai rūpintis savo sveikata.",
      ],
      recommended_blogs_label: "Aleksandros rekomenduojami straipsniai",
      recommended_blogs_ids: [7, 8, 9],
    },
  },
  {
    id: 10,
    name: "Erika Jakutaitė, MD",
    position: "Gyvensenos medicinos specialistė",
    img_src: erika,
    alt: "Erika Jakutaitė",
    content: {
      img_large_src: erika,
      label: "Maži kasdieniai įpročiai lemia didelius sveikatos pokyčius.",
      description: [
        "Erika Jakutaitė – gyvensenos medicinos gydytoja, kurios stiprybė slypi gebėjime pamatyti visumą: nuo mitybos ir fizinio aktyvumo iki streso, miego ir emocinės sveikatos. Ji padeda pacientams keisti įpročius taip, kad pagerėtų jų sveikatos rodikliai, energija ir gyvenimo kokybė.",
        "Telomeroje Erika atlieka svarbų vaidmenį konsultuojant pacientus, kuriems taikomi individualizuoti sveikatos planai pagal genetinius, kraujo ir epigenetinius tyrimus. Ji padeda šiuos planus įgyvendinti praktiškai – prisitaikant prie žmogaus gyvenimo būdo, tempo ir galimybių.",
        "Erika yra baigusi medicinos studijas Lietuvoje, papildomai gilinosi į sveikatos inovacijas tarptautiniuose kursuose, įskaitant programą, vykdytą Harvardo medicinos mokyklos ir MIT bendradarbiavimo pagrindu. Jos požiūris – mokslo pagrįstas, žmogiškas ir orientuotas į ilgalaikį poveikį.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2013–2017</b> Vilniaus universitetas – visuomenės sveikatos bakalauras",
                },
                {
                  id: 2,
                  text: "<b>2018–2020</b> LSMU – gyvensenos medicinos magistrantūra",
                },
                {
                  id: 3,
                  text: "<b>2021</b> Holistinio ugdymo institutas – Fizinis aktyvumas; Sveikatos psichologija",
                },
                {
                  id: 4,
                  text: "<b>2024–2026</b> Žmogaus psichologijos institutas / LSMU – emocinės gerovės konsultavimo pagrindai, podiplominės studijos",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "Darbo patirtis",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2020–2023</b> VšĮ Antakalnio poliklinika – Gyvensenos medicinos specialistė – kompleksinės konsultacijos",
                },
                {
                  id: 2,
                  text: "<b>2021–2023</b> VšĮ Antakalnio poliklinika – Poliligotumo projekto koordinatorė – ES ir SAM projekto vykdymas",
                },
                {
                  id: 3,
                  text: "<b>2022–2023</b> UAB Rezus.lt – Gyvensenos medicinos specialistė – konsultacijos, kūno sudėties analizė",
                },
                {
                  id: 4,
                  text: "<b>2023</b> VšĮ Centro poliklinika – Poliligotumo projekto koordinatorė – ES projekto įgyvendinimas, ataskaitų rengimas, biudžeto valdymas",
                },
                {
                  id: 5,
                  text: "<b>2024–2025</b> VšĮ Centro poliklinika – Gyvensenos medicinos specialistė – individualios konsultacijos, lėtinių ligų prevencija, bendradarbiavimas su komanda",
                },
              ],
            },
          ],
        },
      ],
      quote:
        "Telomera – tai savo srities ekspertų komanda, kuri lyg gyvas organizmas - nestovi vietoje, reaguoja, nuolat kinta. Tai ateitis dabartyje. Telomera yra sprendimas visiems, norintiems susitikti su savo sveikata dar giliau ir, tuo pačiu, išsinešti aiškų apibendrinimą bei individualų sprendimą, kaip naujas žinias pritaikyti savo kasdienybėje",
      recommended_blogs_label: "Vaivos rekomenduojami straipsniai",
      recommended_blogs_ids: [9, 2, 1],
    },
  },
  {
    id: 11,
    name: "Vestina Ramonaitė",
    position: "Pacientų vadybininkė",
    img_src: vestina,
    alt: "Vestina",
    content: {
      img_large_src: vestina,
      label: "",
      description: [],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2020</b> KTU – Biotechnologijų bakalauras",
                },
                {
                  id: 2,
                  text: "<b>2022</b> LSMU – Medicininės chemijos magistras",
                },
              ],
            },
          ],
        },
      ],
      quote:
        "Telomera man yra vieta, kur rūpinimasis sveikata dera su žmogaus gyvenimu, jo poreikiais ir noru jaustis geriau kiekvieną dieną.",
    },
  },
  {
    id: 12,
    name: "Rūta Jovarė, MD",
    position: "Šeimos gydytoja",
    img_src: ruta,
    alt: "Rūta Jovarė",
    content: {
      img_large_src: ruta,
      label: "Ilgaamžiškumas prasideda nuo supratimo, kaip jaučiamės šiandien.",
      description: [
        "Rūta Jovarė – gydytoja, sveikatos optimizavimo ir ilgaamžiškumo specialistė, konsultuojanti žmones, siekiančius pagerinti savijautą, sulėtinti senėjimą ir priimti moksliškai pagrįstus sprendimus dėl savo sveikatos. Jos darbo pagrindas – holistinis požiūris, apjungiantis fiziologinius duomenis, gyvenimo būdo vertinimą ir ilgalaikių pokyčių planavimą.",
        "Telomeroje dr. Rūta padeda pacientams susiorientuoti tarp sudėtingų sveikatos rodiklių ir tyrimų, pateikdama aiškias, individualizuotas konsultacijas. Ji remiasi naujausiais ilgaamžiškumo tyrimais, tačiau visuomet išlieka arti žmogaus – aiškindama, ką sveikata reiškia kasdienybėje.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2015–2021</b> LSMU – Medicina",
                },
                {
                  id: 2,
                  text: "<b>2018/2019</b> Erasmus – Madridas, Ispanija – 6 mėnesių studijos",
                },
                {
                  id: 3,
                  text: "<b>2021–2022</b> LSMU – Rezidentūra LOR",
                },
                {
                  id: 4,
                  text: "<b>2022–2025</b> LSMU – Šeimos medicinos rezidentūra",
                },
              ],
            },
          ],
        },
      ],
      quote: [
        "Telomera man yra apie atradimą ir žinojimą. Požiūris į pacientą - visapusiškas: vertinami lūkesčiai, tikslai ir sveikatos būklė iš visų pusių, neapsiribojant vienu simptomu ar noru.",
        "Kai dirba visa komanda ir kartu su pacientu kuriamas kompleksinis planas, rezultatai pasiekiami aiškiau ir efektyviau.",
        "Svarbiausia - viskas individualizuota ir pritaikyta konkrečiam žmogui, todėl natūraliai kuriasi artimesnis ryšys ir bendradarbiaujant tikslai pasiekiami greičiau.",
      ],
      recommended_blogs_label: "Rūtos rekomenduojami straipsniai",
      recommended_blogs_ids: [7, 8, 9],
    },
  },
  {
    id: 13,
    name: "Jolita Staikūnienė, MD",
    position: "Šeimos gydytoja",
    img_src: jolita,
    alt: "Jolita Staikūnienė",
    content: {
      img_large_src: jolita,
      label:
        "Kiekvienas žmogus nusipelno ne tik gydymo, bet ir tikro supratimo.",
      description: [
        "Jolita Staikūnienė – šeimos gydytoja, turinti tvirtą klinikinį pagrindą ir gilų domėjimąsi žmogaus psichologija. Baigusi medicinos studijas Lietuvos sveikatos mokslų universitete, ji tęsė šeimos medicinos rezidentūrą Vilniaus universitete. Šiuo metu Jolita gilina žinias kognityvinės ir elgesio psichoterapijos srityje, siekdama dar geriau suprasti pacientų poreikius ir padėti jiems holistiškai. ",
        "Jolitos požiūris į mediciną grindžiamas empatija, atidumu ir nuolatiniu tobulėjimu. Jos tikslas – ne tik gydyti, bet ir įkvėpti žmones rūpintis savo sveikata proaktyviai.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "<b>2019</b> - Baigtas Lietuvos sveikatos mokslų universitetas",
                },
              ],
            },
          ],
        },
      ],
      recommended_blogs_label: "Jolitos rekomenduojami straipsniai",
      recommended_blogs_ids: [3, 1, 2],
    },
  },
  {
    id: 14,
    name: "Luka Griniūtė",
    position: "Pacientų vadybininkė",
    img_src: luka,
    alt: "Luka Griniūtė",
    content: {
      img_large_src: luka,
      label: "Rūpestis prasideda nuo klausymo ir nuoširdaus dėmesio žmogui.",
      description: [
        "Luka Griniūtė – tai pirmasis žmogus, su kuriuo susisiekia dauguma Telomeros pacientų, ir tas, kuris lydi juos per visą sveikatos kelionę. Jos užduotis – užtikrinti, kad kiekvienas klientas gautų aiškią, laiku suteiktą informaciją, atsakymus į visus klausimus ir nuoširdų dėmesį kiekviename žingsnyje.",
        "Luka koordinuoja tyrimų eigą, planuoja konsultacijas ir padeda pacientams suprasti, ko tikėtis kiekvienoje proceso dalyje – nuo pirmo kontakto iki rezultatų aptarimo. Ji rūpinasi, kad pacientų patirtis būtų ne tik sklandi, bet ir žmogiška.",
        "Empatija, kruopštumas ir komunikaciniai įgūdžiai – Lukos stipriosios pusės, kurios padeda Telomeros komandai kurti aukščiausio lygio paslaugą.",
      ],
      achievements: [
        {
          id: 1,
          label: "Išsilavinimas",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "ISM Vadybos ir ekonomikos universitetas – Finansų bakalauras",
                },
                {
                  id: 2,
                  text: "šiuo metu Vilniaus universitetas – Medicinos studijos",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "Darbo patirtis",
          item: [
            {
              id: 1,
              rows: [
                {
                  id: 1,
                  text: "Ernst & Young Baltic – Audito specialistė",
                },
                {
                  id: 2,
                  text: "Telomera klinika – Darbas su pacientais, konsultavimas ir sveikatos planų koordinavimas",
                },
                {
                  id: 3,
                  text: "Vilniaus Antakalnio ligoninė – Slaugos praktika",
                },
                {
                  id: 4,
                  text: "VUL Santaros klinikos – Slaugos praktika",
                },
              ],
            },
          ],
        },
      ],
      quote: [
        "Telomera man yra apie aiškumą sveikatoje.",
        "",
        "Šiandien daug žmonių turi daug informacijos apie save - tyrimus, duomenis, patarimus - bet trūksta vieno dalyko: aiškaus plano.",
        "",
        "Telomeroje mes tai sujungiame į vieną visumą - kad žmogus galėtų ne spėlioti, o suprasti ir veikti.",
        "Ne gydyti pasekmes, o jų išvengti.",
        "",
        "Kai turi tinkamus įrankius - sveikata tampa valdoma.",
        "Ir būtent tai mes čia kuriame.",
      ],
      recommended_blogs_label: "Lukos rekomenduojami straipsniai",
      recommended_blogs_ids: [1, 2, 3],
    },
  },
];
